var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM15.8841 6.49088L18.5507 9.3755C18.8319 9.67966 18.8133 10.1542 18.5091 10.4353C18.205 10.7165 17.7304 10.6979 17.4493 10.3937L16.0833 8.91615V17C16.0833 17.4142 15.7475 17.75 15.3333 17.75C14.9191 17.75 14.5833 17.4142 14.5833 17V8.91615L13.2174 10.3937C12.9362 10.6979 12.4617 10.7165 12.1575 10.4353C11.8534 10.1542 11.8348 9.67966 12.1159 9.3755L14.7826 6.49088C14.9246 6.33732 15.1242 6.25 15.3333 6.25C15.5425 6.25 15.7421 6.33732 15.8841 6.49088ZM9.41667 7V15.0838L10.7826 13.6063C11.0638 13.3021 11.5383 13.2835 11.8425 13.5647C12.1466 13.8458 12.1652 14.3203 11.8841 14.6245L9.21739 17.5091C9.07543 17.6627 8.8758 17.75 8.66667 17.75C8.45754 17.75 8.2579 17.6627 8.11594 17.5091L5.44927 14.6245C5.1681 14.3203 5.18673 13.8458 5.49088 13.5647C5.79504 13.2835 6.26955 13.3021 6.55073 13.6063L7.91667 15.0838V7C7.91667 6.58579 8.25245 6.25 8.66667 6.25C9.08088 6.25 9.41667 6.58579 9.41667 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapVertical);
export default __webpack_public_path__ + "static/media/swap-vertical.013d976c7de1f10b9c4f0b5e0a70da12.svg";
export { ForwardRef as ReactComponent };